///Protocol class every Extension enabler should extend,
export abstract class  ExtensionsDataSource {
    ///Method to populate data source
    abstract enable():void;
  }